// @flow

import ToastManager from 'js-notifications';
import Icon from '../classes/Icon';

const notification = new ToastManager({ offset: window.store.headerHeight, seconds: 10 });

notification.template = ({ type, title, message }: Object): string => `
    <div
        class="notification notification--${type} toast bg-white py-2.5 pr-0 pl-2.5 md:py-5 md:py-2.5 md:pl-5 items-center shadow-md rounded"
    >
        <div class="notification__content relative flex-1 pl-9 md:pl-12">
            ${new Icon({ icon: type === 'success' ? 'check-circle' : 'times-circle', width: 24 }).generate().outerHTML}
            <div class="notification__title font-bold text-base">${title}</div>
            <p class="text-sm mb-0">${message}</p>
        </div>

        <div class="notification__close toast__close flex justify-center items-center cursor-pointer">
            ${new Icon({ icon: 'times', width: 14 }).generate().outerHTML}
        </div>
    </div>
`;

export default notification;
